"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETicketPlaceholderPdf = exports.ReceiptPlaceholderPdf = void 0;
const locales_1 = require("../enums/locales");
exports.ReceiptPlaceholderPdf = {
    [locales_1.Locales.EN]: "ReceiptPlaceholderEN.pdf",
    [locales_1.Locales.FR]: "ReceiptPlaceholderFR.pdf",
    [locales_1.Locales.ES]: "ReceiptPlaceholderEN.pdf",
    [locales_1.Locales.DE]: "ReceiptPlaceholderDE.pdf",
};
exports.ETicketPlaceholderPdf = {
    [locales_1.Locales.EN]: "ETicketPlaceholderEN.pdf",
    [locales_1.Locales.FR]: "ETicketPlaceholderFR.pdf",
    [locales_1.Locales.ES]: "ETicketPlaceholderEN.pdf",
    [locales_1.Locales.DE]: "ETicketPlaceholderDE.pdf",
};
